import { render, staticRenderFns } from "./SearchRating.vue?vue&type=template&id=338923fb"
import script from "./SearchRating.vue?vue&type=script&lang=js"
export * from "./SearchRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports